// OCR wrapper using Tesseract.js for Malaysian IC and payslip scanning
// Provides graceful fallback to demo mode if Tesseract.js is not installed

let worker = null;

export async function initializeWorker() {
  // Tesseract.js is optional - OCR runs in demo mode when not installed
  // To enable real OCR: npm install tesseract.js
  console.info('OCR Service: Running in demo mode (Tesseract.js not installed)');
  return null;
}

export async function scanIC(imageFile) {
  // Try real OCR first
  if (worker) {
    try {
      const { data } = await worker.recognize(imageFile);
      const icMatch = data.text.match(/(\d{6})-?(\d{2})-?(\d{4})/);
      const nameLines = data.text.split('\n').filter(l => l.length > 5 && /^[A-Z\s]+$/.test(l.trim()));
      return {
        fullName: nameLines[0]?.trim() || '',
        icNumber: icMatch ? icMatch[0].replace(/-/g, '') : '',
        rawText: data.text,
        confidence: data.confidence,
        isDemo: false,
      };
    } catch (e) { /* fall through to demo */ }
  }
  // Demo fallback
  return {
    fullName: 'AHMAD FAIZAL BIN IBRAHIM',
    icNumber: '940221025055',
    rawText: '[Demo Mode] IC scan simulated',
    confidence: 95,
    isDemo: true,
  };
}

export async function scanPayslip(imageFile) {
  if (worker) {
    try {
      const { data } = await worker.recognize(imageFile);
      const salaryMatch = data.text.match(/(?:GROSS|BASIC|GAJI|SALARY|PENDAPATAN)[:\s]*RM?\s*([\d,]+\.?\d*)/i);
      const companyLines = data.text.split('\n').slice(0, 5).filter(l => l.trim().length > 3);
      return {
        monthlyIncome: salaryMatch ? salaryMatch[1].replace(/,/g, '') : '',
        employerName: companyLines[0]?.trim() || '',
        rawText: data.text,
        confidence: data.confidence,
        isDemo: false,
      };
    } catch (e) { /* fall through */ }
  }
  // Demo fallback
  return {
    monthlyIncome: '5800',
    employerName: 'PETRONAS DAGANGAN BHD',
    rawText: '[Demo Mode] Payslip scan simulated',
    confidence: 92,
    isDemo: true,
  };
}

export async function terminateWorker() {
  if (worker) {
    await worker.terminate();
    worker = null;
  }
}
